import { engravingDefaultContent } from "@/constData/engravingData.js";

/**
 * 金牌客製化步驟前後跳躍時，會更新金牌客製化內容至 Store
 * 客製化文字中根據每塊金牌的 engravingContentType 決定內容格式
 *
 * @param {Object} store - Vuex store 實例
 * @param {string} newComponentCode - 新的 component code
 * @param {string} currentType - 當前的 engraving_content.type
 * @param {Object} currentContent - 當前的 engraving_content.content
 */
export function updateEngravingContent(
  store,
  newComponentCode,
  currentType,
  currentContent
) {
  const newType =
    store.getters.customizeMetalEngravingContentTypeByComponentCode(
      newComponentCode
    );

  let newContent;
  if (currentType === newType) {
    // Type 相同
    if (newType === "default") {
      // default 類型才有 respect 欄位
      // 因不同的金牌， respect 內容會不同，故重置 respect 欄位
      newContent = {
        ...currentContent,
        respect: "",
      };
    } else {
      // 其他類型（sacredObject, commemorative_*）沒有 respect 欄位，直接保留 content
      newContent = {
        ...currentContent,
      };
    }
  } else {
    // Type 不同：使用新 type 的預設值
    newContent = JSON.parse(JSON.stringify(engravingDefaultContent[newType]));
  }

  store.dispatch("updateCostom", {
    key: "engraving_content",
    content: {
      type: newType,
      content: newContent,
    },
  });
}
